import { ParagraphComponent, SubtitleComponent, ButtonComponent, ModalComponent, ProductModalComponent } from '..';
import './wideProductCard.style.scss';
import { useNavigate } from 'react-router-dom';
import imagePlaceholder from '../../assets/images/imagePlaceholder.svg';
import { Product } from '../productCard/data';
import { useTranslation } from 'react-i18next';

interface Props {
    data: Product;
    style?: any;
    className?: any;
    onClick?: any;
}

export default function WideProductCardComponent(props: Props) {
    const { data, style, className, onClick } = props;
    const navigate = useNavigate();
    const { t, i18n } = useTranslation();

    return (
        <>
            {
                <div key={data.id} className={`wideProductCard ${className}`} style={style} onClick={() => navigate("/" + i18n.language + t('navbar.routes.equipment') + "/" + data.ref)}>
                    <div className={`imgBackground ${data.image === undefined ? 'placeholderBg' : 'noImgBg'}`}>
                        {data.image === undefined ? (
                            <img src={imagePlaceholder} alt={`Placeholder image`} />
                        ) : (
                            <img src={data.image} alt={`Product image of ${data.title}`} />
                        )}
                    </div>
                    <div className="productCardContent">
                        <h2><ParagraphComponent className='productTitle'>{data.title}</ParagraphComponent></h2>
                        <ParagraphComponent className='productBrand'>{data.brand}</ParagraphComponent>
                        <ButtonComponent onClick={() => navigate("/" + i18n.language + t('navbar.routes.equipment') + "/" + data.ref)}>{t('productsCard.details')}</ButtonComponent>
                    </div>
                </div>
            }
        </>
    );
} 